import React, { memo, useMemo } from "react";
import { QUESTIONS_TABLE } from "../../constants/questions-table";
import { terminosYCondicionesHogarFlexPdf } from "../../../../constants/files";
import Datalayer from "../../../../libs/vendors/data-layer";
import { CLICK_ACTIONS, CLICK_DESCRIPTION } from "../../../../constants/datalayer";

const QuestionsTable = () => {
    const questionsTable = useMemo(() => QUESTIONS_TABLE, []);

    const openPdf = () => {
        Datalayer.sendClickAction(
            "Inicio",
            `${CLICK_ACTIONS.SELECT_LINK}: ${CLICK_DESCRIPTION.TERMS_CONDITIONS_HOGARFLEX}`
        );
    };

    return (
        <>
            {questionsTable &&
                questionsTable.map(({ id, title, content, hasLink }) => (
                    <div key={id} className="landing-who-can-hire__item">
                        <div className="landing-who-can-hire__item-title">{title}</div>
                        <div className="landing-who-can-hire__item-content">
                            {content}
                            {hasLink && (
                                <a
                                    id="download-terms-and-conditions-pdf"
                                    href={terminosYCondicionesHogarFlexPdf}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={openPdf}
                                >
                                    Conoce más
                                </a>
                            )}
                        </div>
                    </div>
                ))}
        </>
    );
};

export default memo(QuestionsTable);
